import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { CategoriesService } from '~app/modules/generic/services/categories.service';
import { IS_UUID } from '../../../../server/constants/regexp';
import { APP_CATEGORY_ROUTE } from '~shared/constants';
import { HomepageNavigatorService } from '~shared/modules/homepage-navigator/homepage-navigator.service';
import { Category } from '~app/modules/generic/models';

@Injectable({
  providedIn: 'root',
})
export class CategoryPLPGuard implements CanLoad {
  constructor(
    private router: Router,
    private routerHome: HomepageNavigatorService,
    private categoriesService: CategoriesService,
  ) {}

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    const slugSegment = segments[1];
    if (!slugSegment?.path || IS_UUID.test(slugSegment.path)) {
      return this.routerHome.navigateToHomepage();
    }
    return this.loadCategory(slugSegment.path);
  }

  private loadCategory(slug: string): Observable<boolean> {
    return this.categoriesService.getCategoryByIdOrSlug(slug).pipe(
      switchMap((categoryResponse: Category) => {
        if (!categoryResponse?.id) {
          return this.routerHome.navigateToHomepage();
        }
        return of(true)
      }),
      catchError((err) => {
        const redirectTo = err.sourceError?.error?.redirect;
        if (redirectTo) {
          return this.router.navigate([`/${APP_CATEGORY_ROUTE}/${redirectTo}`]);
        }
        return this.routerHome.navigateToHomepage();
      })
    );
  }
}
